module.exports = __webpack_public_path__ + "static/media/banner_img.c66c4cf9.png";